export enum ModalTypes {
  confirm = 'confirm',
  alert = 'alert',
  form = 'form',
  info = 'info',
  empty = 'empty',
}
